import React, {PropTypes} from "react";


class HrAdminNavigation extends React.Component {

    constructor(props) {
        super();
        this.getAccess = this.getAccess.bind(this);
    }

    getAccess(role) {
        if(role === "peopleSearch") {
            return this.props.roles.peopleSearch;
        } else if(role === "exits") {
            return this.props.roles.exits;
        } else if(role === "exitsFnF") {
            return this.props.roles.exitsFnF;
        } else if(role === "onBoarding") {
            return this.props.roles.onBoarding;
        } else if(role === "onBoardingExpected") {
            return this.props.roles.onBoardingExpected;
        } else if(role === "leave"){
            return this.props.roles.leave;
        } else if(role === "upload") {
            return this.props.roles.upload;
        } else if(role === "download") {
            return this.props.roles.download;
        } else if(role === "ctcSplit"){
            return this.props.roles.ctcSplit;
        } else if(role === "abscond"){
            return this.props.roles.abscond
        } else {
            return false;
        }
    }

    render() {
        return (
            <ul className="nav nav-tabs tabs responsive" role="tablist">
                {this.props.options.map((menu)=> {
                    let show = this.getAccess(menu.role);
                    if(show) {
                        return <li
                            className={window.location.hash.split('?')[0] == menu.url || window.location.hash.split('?')[0] == menu.url2 ? "active" : null}
                            rel="apply"><a href={menu.url} rel="apply" role="tab" data-toggle="tab">{menu.text}</a></li>
                    } else {
                        return null;
                    }
                })}
            </ul>
        );
    }
}

HrAdminNavigation.defaultProps = {
    options: []
}

HrAdminNavigation.propTypes = {
    options: React.PropTypes.array

};

export default HrAdminNavigation;





/** WEBPACK FOOTER **
 ** ./src/components/common/HrAdminNavigation.js
 **/